<template>
  <div class="">
    <div class="audio-wrapper">
      <swiper :options="swiperOption" ref="swiper">
        <swiper-slide v-for="(audio, index) in audios" :key="index">
          <div class="audio-title">
            <h3>{{audio.title}}</h3>
          </div>
          <AudioItem :audioData="audio" :class="lngClass"></AudioItem>
        </swiper-slide>
      </swiper>
      <div class="btn-audio-prev"></div>
      <div class="btn-audio-next"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import AudioItem from "@/components/AudioItem.vue";

export default {
  components: {
    AudioItem
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: ".btn-audio-next",
          prevEl: ".btn-audio-prev"
        }
      }
    };
  },
  computed: {
    ...mapState(["extension"]),
    ...mapGetters(["lngClass"]),
    audios() {
      return this["extension"][0];
    }
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getExtension"]),
    getPageData(page_num = 0) {
      const param = {
        category: "手机铃声",
        page_num,
        page_size: 1000
      };
      this.getExtension(param);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.audio-wrapper {
  position: relative;
  .audio-title {
    margin-bottom: 1rem;
    text-align: center;

    @include title-h3(1rem);
    h3 {
      height: 1.2rem;
      line-height: 1.2;

      &::before,
      &::after {
        height: 1.2rem;
      }

      &::before {
        background-image: url("~@/assets/img/audio/title-left.png");
      }

      &::after {
        background-image: url("~@/assets/img/audio/title-right.png");
      }
    }
  }

  .swiper-container {
    overflow: visible;
  }

  .btn-audio-prev,
  .btn-audio-next {
    position: absolute;
    z-index: 10;
    top: 8rem;
    width: 2rem;
    height: 2rem;
    background-repeat: no-repeat;
    background-size: 100%;
    outline: none;
  }

  .btn-audio-prev {
    left: 0.5rem;
    background-image: url("~@/assets/img/audio/audio-prev.png");
  }

  .btn-audio-next {
    right: 0.5rem;
    background-image: url("~@/assets/img/audio/audio-next.png");
  }

  .swiper-button-disabled {
    opacity: 0.5;
  }

  .lng {
    &::after {
      display: none;
    }
  }
}
</style>

